export default __webpack_public_path__ + "static/media/bull_nft.6c87b7bf.jpeg";